import connect from "@classdojo/web/utils/hoc/connect";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { displayClose } from "src/pods/realtime";
import { appMetadataTimer, selectTime, sendTime, Timer } from "src/pods/timer";
import PresentationPage from "src/shared/components/PresentationPage";
import TimerDisplay from "./TimerDisplay";

type TimerDisplayContainerProps = {
  time: Timer;
  fullscreen: boolean;
  sendTime: (time: Timer) => void;
  displayClose: VoidFunction;
};

const mapStateToProps = { time: selectTime, fullscreen: () => true };
const mapDispatchToProps = { sendTime, displayClose };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<TimerDisplayContainerProps>) => (
  <PresentationPage
    {...appMetadataTimer()}
    onRequestHide={props.displayClose}
    closeButtonAriaLabel={autoTranslate("Close timer display")}
  >
    <TimerDisplay sendTime={props.sendTime} time={props.time} fullscreen={!!props.fullscreen} shouldRingBell={true} />
  </PresentationPage>
));
